export default function TermikoSection() {
  const benefits = [
    { icon: 'ri-tools-line', text: 'Si adatta a qualsiasi foro finestra senza sopralluogo' },
    { icon: 'ri-send-plane-2-line', text: 'Kit spedito e installato in poche ore' },
    { icon: 'ri-shield-check-line', text: 'Certificazione Usb=1 W/m²K inclusa' },
    { icon: 'ri-registered-line', text: 'Brevetto registrato — tecnologia esclusiva' },
  ];

  return (
    <section
      id="termiko"
      aria-label="Termiko® – Controtelaio in kit universale brevettato per finestre"
      className="bg-[#0D0D0D] py-16 md:py-24 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-14">
          <div>
            <span
              className="text-[#7FCDCD] text-xs font-semibold uppercase tracking-widest block mb-4"
              style={{ fontFamily: "'DM Sans', sans-serif" }}
            >
              — Prodotto Esclusivo Brevettato
            </span>
            {/* Termiko logo */}
            <img
              src="https://storage.readdy-site.link/project_files/bd8f2552-0d66-4173-83ae-55ad3331b93a/f386838a-6af0-4b38-9a2c-fd8d2926db7e_Screenshot-2026-03-31-10.05.18.png"
              alt="Termiko® – Controtelaio in kit universale brevettato"
              title="Termiko® – Marchio registrato, controtelaio PVC brevettato per finestre"
              className="h-10 md:h-14 w-auto object-contain mb-4"
            />
            <p
              className="text-white/40 text-sm leading-relaxed max-w-md"
              style={{ fontFamily: "'DM Sans', sans-serif" }}
            >
              Il controtelaio brevettato che si adatta a tutti i fori finestra senza sopralluogo.
              Installazione immediata, zero perdite di tempo in cantiere.
            </p>
          </div>

          {/* Benefits — desktop: affiancati all'header */}
          <div className="hidden md:grid grid-cols-2 gap-3 max-w-sm flex-shrink-0">
            {benefits.map((b) => (
              <div key={b.text} className="flex items-start gap-2.5">
                <div className="w-7 h-7 flex items-center justify-center bg-[#7FCDCD]/10 rounded-lg flex-shrink-0 mt-0.5">
                  <i className={`${b.icon} text-[#7FCDCD] text-sm`} />
                </div>
                <p
                  className="text-white/50 text-xs leading-snug"
                  style={{ fontFamily: "'DM Sans', sans-serif" }}
                >
                  {b.text}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Main content: video + info */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 md:gap-8 items-start">

          {/* Video — occupa 3/5 su desktop */}
          <div className="lg:col-span-3">
            <div className="relative rounded-2xl overflow-hidden bg-black w-full">
              {/* Label muted */}
              <div className="absolute top-3 left-3 z-10 flex items-center gap-1.5 bg-black/60 backdrop-blur-sm rounded-full px-3 py-1">
                <i className="ri-volume-mute-line text-white/60 text-xs" />
                <span
                  className="text-white/50 text-[10px]"
                  style={{ fontFamily: "'DM Sans', sans-serif" }}
                >
                  Silenzioso
                </span>
              </div>
              <video
                src="https://termiko.it/wp-content/uploads/video-TermiKo-Finestra.mp4"
                autoPlay
                muted
                loop
                playsInline
                controls
                className="w-full block"
                style={{ maxHeight: '480px', objectFit: 'contain', background: '#000' }}
                aria-label="Video installazione Termiko® – Controtelaio in kit universale per finestre"
              />
            </div>
          </div>

          {/* Info panel — occupa 2/5 su desktop */}
          <div className="lg:col-span-2 flex flex-col gap-5">

            {/* Badge brevetto */}
            <div className="flex items-center gap-3 border border-[#7FCDCD]/25 rounded-xl px-4 py-3 bg-[#7FCDCD]/5">
              <div className="w-9 h-9 flex items-center justify-center bg-[#7FCDCD]/15 rounded-lg flex-shrink-0">
                <i className="ri-award-fill text-[#7FCDCD] text-base" />
              </div>
              <div>
                <div
                  className="text-[#7FCDCD] font-black text-base leading-none mb-0.5"
                  style={{ fontFamily: "'Raleway', sans-serif" }}
                >
                  U<sub className="text-xs">sb</sub> = 1 W/m²K
                </div>
                <div
                  className="text-white/40 text-xs"
                  style={{ fontFamily: "'DM Sans', sans-serif" }}
                >
                  Certificazione termica ufficiale
                </div>
              </div>
            </div>

            {/* Benefits mobile — visibili solo su mobile */}
            <div className="md:hidden grid grid-cols-1 gap-3">
              {benefits.map((b) => (
                <div key={b.text} className="flex items-start gap-2.5">
                  <div className="w-7 h-7 flex items-center justify-center bg-[#7FCDCD]/10 rounded-lg flex-shrink-0 mt-0.5">
                    <i className={`${b.icon} text-[#7FCDCD] text-sm`} />
                  </div>
                  <p
                    className="text-white/50 text-xs leading-snug pt-1"
                    style={{ fontFamily: "'DM Sans', sans-serif" }}
                  >
                    {b.text}
                  </p>
                </div>
              ))}
            </div>

            {/* Come funziona */}
            <div className="border border-white/8 rounded-xl p-5">
              <p
                className="text-white/30 text-xs font-semibold uppercase tracking-widest mb-4"
                style={{ fontFamily: "'DM Sans', sans-serif" }}
              >
                Come funziona
              </p>
              <div className="space-y-4">
                {[
                  { step: '01', text: 'Misuri il foro finestra e ordini il kit su misura' },
                  { step: '02', text: 'Ricevi il kit entro 48h, pronto da montare' },
                  { step: '03', text: 'Installi in poche ore — senza sopralluogo' },
                ].map((s) => (
                  <div key={s.step} className="flex items-start gap-3">
                    <span
                      className="text-[#7FCDCD] font-black text-xs flex-shrink-0 mt-0.5"
                      style={{ fontFamily: "'Raleway', sans-serif" }}
                    >
                      {s.step}
                    </span>
                    <p
                      className="text-white/50 text-xs leading-snug"
                      style={{ fontFamily: "'DM Sans', sans-serif" }}
                    >
                      {s.text}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* CTA */}
            <div className="flex flex-col gap-2.5 pt-1">
              <a
                href="#form"
                onClick={(e) => { e.preventDefault(); document.getElementById('form')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="flex items-center justify-center gap-2 bg-[#7FCDCD] hover:bg-[#6bbaba] text-white font-black py-4 rounded-xl transition-all text-sm whitespace-nowrap cursor-pointer"
                style={{ fontFamily: "'DM Sans', sans-serif" }}
              >
                <i className="ri-file-list-3-line" />
                Preventivo Termiko®
              </a>
              <a
                href="https://termiko.it"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="flex items-center justify-center gap-2 border border-white/15 hover:border-white/35 text-white/50 hover:text-white font-semibold py-3.5 rounded-xl transition-all text-sm whitespace-nowrap cursor-pointer"
                style={{ fontFamily: "'DM Sans', sans-serif" }}
              >
                <i className="ri-external-link-line" />
                Scopri termiko.it
              </a>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
}
